// extracted by css-extract-rspack-plugin
export default {"cls1":"ReferenceEvaluationPage-cls1_Epq","cls2":"ReferenceEvaluationPage-cls2_JBm ReferenceEvaluationPage-cls1_Epq","fadeInUp":"ReferenceEvaluationPage-fadeInUp_5iP"};